import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import styles from '../Calculator.module.css';

const StepIntro: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className={styles.step}>
            <div className={styles.header}>
                <h3 className={styles.title}>{t('calculator.title')}</h3>
                <p className={styles.description}>{t('calculator.subtitle')}</p>
            </div>
        </div>
    );
};

export default StepIntro;
